// import React from "react";
// import { useTatGraphData } from "./TatGraphData";
// import "./index.scss";

// const SkeletonBar = () => (
//   <div className="bar-group">
//     <div className="bar bar--skeleton" style={{ height: "60%" }} />
//   </div>
// );

// const TATHistoryGraph = () => {
//   const { chartData, loading, error } = useTatGraphData();

//   const maxValue = loading
//     ? 20
//     : Math.max(...chartData.map((item) => Number(item.value) || 0), 0);

//   const getInterval = (max) => {
//     const targetSteps = 5;

//     let interval = Math.ceil(max / targetSteps);

//     if (interval <= 10) return 10;
//     if (interval <= 20) return 20;
//     if (interval <= 30) return 30;
//     if (interval <= 50) return 50;
//     if (interval <= 100) return 100;

//     return Math.ceil(interval / 100) * 100;
//   };

//   const INTERVAL = getInterval(maxValue);

//   const yAxisMax = Math.ceil(maxValue / INTERVAL) * INTERVAL + INTERVAL;

//   const yAxisValues = [];

//   for (let value = yAxisMax; value >= 0; value -= INTERVAL) {
//     yAxisValues.push(value);
//   }

//   return (
//     <div className="pending-chart-card">
//       <div className="card-header">
//         <div className="card-header__top">
//           <div>
//             <h2>Pending Cases by Stakeholder</h2>
//             <p>Number of pending cases grouped by stakeholder type.</p>
//           </div>

//           {!loading && (
//             <div className="chart-legend">
//               {chartData.map((item) => (
//                 <div key={item.label} className="chart-legend__item">
//                   <span
//                     className="chart-legend__dot"
//                     style={{
//                       background: item.color,
//                     }}
//                   />
//                   <span className="chart-legend__label">{item.label}</span>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {error && <p className="chart-error">{error}</p>}
//       </div>

//       <div className="chart-wrapper">
//         <div
//           className="y-axis"
//           style={{
//             "--rows": yAxisValues.length,
//           }}
//         >
//           {yAxisValues.map((value) => (
//             <div key={value} className="y-label">
//               {value}
//             </div>
//           ))}
//         </div>

//         <div className="chart-section">
//           <div
//             className="chart-area"
//             style={{
//               "--rows": yAxisValues.length,
//             }}
//           >
//             {yAxisValues.map((value) => (
//               <div key={value} className="grid-line" />
//             ))}

//             <div className="bars-container">
//               {loading
//                 ? [1, 2, 3].map((k) => <SkeletonBar key={k} />)
//                 : chartData.map((item) => {
//                     const heightPercent = (item.value / yAxisMax) * 100;

//                     return (
//                       <div className="bar-group" key={item.label}>
//                         <div
//                           className="bar"
//                           style={{
//                             height: `${heightPercent}%`,
//                             background: `linear-gradient(
//                               180deg,
//                               ${item.color} 0%,
//                               ${item.color}99 100%
//                             )`,
//                           }}
//                         >
//                           <span className="value">{item.value}</span>
//                         </div>
//                       </div>
//                     );
//                   })}
//             </div>
//           </div>

//           <div className="x-axis-labels">
//             {loading
//               ? [1, 2, 3].map((k) => (
//                   <div key={k} className="x-label x-label--skeleton" />
//                 ))
//               : chartData.map((item) => (
//                   <div key={item.label} className="x-label">
//                     <span
//                       className="x-label__dot"
//                       style={{
//                         background: item.color,
//                       }}
//                     />
//                     {item.label}
//                   </div>
//                 ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TATHistoryGraph;

import React from "react";
import { useTatGraphData } from "./TatGraphData";
import "./index.scss";

const SkeletonBar = () => (
  <div className="bar-group">
    <div className="bar bar--skeleton" style={{ height: "60%" }} />
  </div>
);

const TATHistoryGraph = () => {
  const { chartData, loading, error } = useTatGraphData();

  // =========================
  // Dynamic Y-Axis Calculation
  // =========================

  const maxValue = loading
    ? 20
    : Math.max(...chartData.map((item) => Number(item.value) || 0), 0);

  const getInterval = (max) => {
    const targetSteps = 5;

    let interval = Math.ceil(max / targetSteps);

    if (interval <= 10) return 10;
    if (interval <= 20) return 20;
    if (interval <= 30) return 30;
    if (interval <= 50) return 50;
    if (interval <= 100) return 100;

    return Math.ceil(interval / 100) * 100;
  };

  const INTERVAL = getInterval(maxValue);

  const yAxisMax = Math.ceil(maxValue / INTERVAL) * INTERVAL + INTERVAL;

  const yAxisValues = Array.from(
    { length: yAxisMax / INTERVAL + 1 },
    (_, index) => yAxisMax - index * INTERVAL,
  );

  return (
    <div className="pending-chart-card">
      {/* =========================
          HEADER
      ========================= */}
      <div className="card-header">
        <div className="card-header__top">
          <div>
            <h2>Pending Cases by Stakeholder</h2>
            <p>Number of pending cases grouped by stakeholder type.</p>
          </div>

          {!loading && (
            <div className="chart-legend">
              {chartData.map((item) => (
                <div key={item.label} className="chart-legend__item">
                  <span
                    className="chart-legend__dot"
                    style={{
                      background: item.color || "#3b82f6",
                    }}
                  />

                  {/* <span className="chart-legend__label">{item.label}</span> */}
                </div>
              ))}
            </div>
          )}
        </div>

        {error && <p className="chart-error">{error}</p>}
      </div>

      {/* =========================
          CHART
      ========================= */}
      <div className="chart-wrapper">
        {/* Y Axis */}
        <div
          className="y-axis"
          style={{
            "--rows": yAxisValues.length,
          }}
        >
          {yAxisValues.map((value) => (
            <div key={value} className="y-label">
              {value}
            </div>
          ))}
        </div>

        {/* Chart Section */}
        <div className="chart-section">
          <div
            className="chart-area"
            style={{
              "--rows": yAxisValues.length,
              "--grid-count": yAxisValues.length - 1,
            }}
          >
            {/* Grid Lines */}
            {yAxisValues.map((value) => (
              <div key={`grid-${value}`} className="grid-line" />
            ))}

            {/* Bars */}
            <div className="bars-container">
              {loading
                ? [1, 2, 3].map((key) => <SkeletonBar key={key} />)
                : chartData.map((item) => {
                    const value = Number(item.value) || 0;

                    const heightPercent =
                      yAxisMax > 0 ? (value / yAxisMax) * 100 : 0;

                    return (
                      <div className="bar-group" key={item.label}>
                        <div
                          className="bar"
                          style={{
                            height: `${heightPercent}%`,
                            background: `linear-gradient(
                            180deg,
                            ${item.color || "#3b82f6"} 0%,
                            ${item.color || "#3b82f6"}CC 100%
                          )`,
                          }}
                          title={`${item.label}: ${value}`}
                        >
                          <span className="value">{value}</span>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>

          {/* X Axis Labels */}
          <div className="x-axis-labels">
            {loading
              ? [1, 2, 3].map((key) => (
                  <div key={key} className="x-label x-label--skeleton" />
                ))
              : chartData.map((item) => (
                  <div key={item.label} className="x-label">
                    <span
                      className="x-label__dot"
                      style={{
                        background: item.color || "#3b82f6",
                      }}
                    />

                    <span>{item.label}</span>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TATHistoryGraph;
